
export default () => {
    if (document.querySelector('.page-template-page-archive') !== null) {
        if(nobox.currentLang == "en"){
            var loadmoreTxt = "Load more";
            var nomoreTxt = "No more posts";
            var loadingTxt = "Loading...";
            var nomorepostsTxt = "No posts to be shown";
        } else {
            var loadmoreTxt = "Ladda fler";
            var nomoreTxt = "Inga fler poster att visa";
            var loadingTxt = "Laddar...";
            var nomorepostsTxt = "Inga fler poster att visa";
        }

        const loadmoreBtn = document.querySelector('#loadMore');
        const categoryBtn = document.getElementsByClassName('category');
        const postContainer = document.querySelector('.posts.flexRowWrapper.container');


        let dataLM = { //data load more
            action: 'nobox_load_more_posts',
            offset: 0,
            category: '',
            archive: window.location.href,
            exclude: '',
        };
        var dataFP = { //data filter posts
            action: 'nobox_filter_posts',
            category: '',
            archive: window.location.href,
            exclude: '',
        };

        loadmoreBtn.addEventListener('click', (e) => {
            dataLM = { //data load more
                action: 'nobox_load_more_posts',
                offset: dataLM.offset,
                category: dataFP.category,
                archive: window.location.href,
            };
            loadmoreBtn.innerHTML = loadingTxt;
            dataLM.offset += 10;

            $.post(
                nobox.ajaxUrl,
                dataLM,
                (data, response) => {
                    if (response === 'success') {
                        if (data.result.length > 0) {
                            data.result.forEach((post) => {
                                postContainer.innerHTML += post;
                            });
                            loadmoreBtn.innerHTML = loadmoreTxt;
                        } else {
                            dataLM.offset -= 10;
                            loadmoreBtn.innerHTML = nomoreTxt;
                            loadmoreBtn.classList.add("empty");
                        }
                    }
                }
            );
        });
        for (var i = 0; i < categoryBtn.length; i++) {
            categoryBtn[i].addEventListener('click', (e) => {
                if(e.srcElement.classList.contains('link')){
                    return true;
                } else {
                    e.preventDefault();
                }

                if(document.querySelector('.first')) {
                    document.querySelector('.first').style.display = 'none';
                }
                dataFP.exclude = "";
                dataLM.exclude = "";

                postContainer.innerHTML = '<div class="loading"><span>.</span><span>.</span><span>.</span></div>';

                for (var i = 0; i < categoryBtn.length; i++) {
                    categoryBtn[i].classList.remove('active');
                }
                e.target.classList.add('active');

                dataFP.category = e.target.getAttribute('data-category');
                dataLM.offset = 0;

                if(dataFP.category == ''){
                    const exc = [ document.getElementsByClassName('exclude')[0].value, document.getElementsByClassName('exclude')[1].value ];
                    dataFP.exclude = exc;
                    dataLM.exclude = exc;
                }

                $.post(
                    nobox.ajaxUrl,
                    dataFP,
                    (data, response) => {
                        if (response === 'success') {
                            if (data.result.length > 0) {
                                postContainer.innerHTML = "";
                                data.result.forEach((post) => {
                                    postContainer.innerHTML += post;
                                });
                                loadmoreBtn.classList.remove("empty");
                                loadmoreBtn.innerHTML = loadmoreTxt;

                                if(dataFP.category == ''){
                                    if(document.querySelector('.first')) {
                                        document.querySelector('.first').style.display = 'flex';
                                    }
                                }
                            } else {
                                postContainer.innerHTML = "<h3>"+ nomorepostsTxt +"</h3>";
                            }
                        }
                    }
                );
            });
        }
    }
};


